export const IS_DEV = process.env.NEXT_PUBLIC_ENVIRONMENT === "development";
export const IS_PROD = process.env.NEXT_PUBLIC_ENVIRONMENT === "production";

export const NO_DATA_PLACEHOLDER = "-";

export const EMPLOYEE_STATUSES = {
  ACTIVE: "active",
};

export const APPOINTMENT_STATUSES = {
  ACTIVE: "active",
  DONE: "done",
  CANCELLED: "cancelled",
};

export const REASONS_KEYS = {
  Example: "Example",
};

export const REASON_LABELS = {
  [REASONS_KEYS.Example]: "Example",
};

export const COOKIE_APPOINTMENT_KEY = "appointment";
export const COOKIE_APPOINTMENT_DIVIDER = "-";

export const ID_LINKS = {
  CONTACT_US: "kontakt",
};

// TODO: Update company name
export const COMPANY_NAME = "FlexiBooking.sk";

export const COMPANY_TITLE = "FlexiBooking.sk";

// export const COMPANY_EMAIL = "TODO";
// export const COMPANY_SUPPORT_EMAIL = "TODO";

// export const COMPANY_PHONE_NUMBER = "TODO";

export const DATE_FORMAT = "yyyy-MM-dd";
export const PRETTY_DATE_FORMAT = "dd. MM. yyyy";
export const PRETTY_DATETIME_FORMAT = "HH:mm dd. MM. yyyy";
